import React from 'react'
import classNames from 'classnames'
import kebabCase from 'lodash/kebabCase'
import { AsH1, TitleLG } from '@/atoms/Text'
import { BasicCarousel } from '@/molecules/BasicCarousel'
import { LinkViewModel } from '@/services/RenderService/types'
import { SquareTileCard } from './SquareTileCard'

interface Props extends React.HTMLAttributes<HTMLElement> {
  id?: string
  title?: string
  images?: string[]
  contentLinks?: LinkViewModel[]
  testId?: string
  className?: string
  padding?: boolean
}

export const SquareRowCollection: React.FC<Props> = ({
  id,
  title,
  images,
  contentLinks,
  testId = 'square-row-collection',
  className = 'w-full',
  padding,
}) => {
  if (!images?.length && !contentLinks?.length) return null

  const items: LinkViewModel[] =
    contentLinks ??
    images?.map(
      (src, idx) =>
        ({
          id: `image-${idx}`,
          linkUrl: '#',
          imageUrl: src,
          landscapeUrl: src,
          alt: 'Album Art',
        } as LinkViewModel),
    ) ??
    []

  return (
    <div id={id ?? (title ? kebabCase(title) : undefined)} data-testid={testId} className={className}>
      {title && (
        <header>
          <TitleLG weight="bold" as={AsH1} className="px-4 sm:px-8 md:px-12 xl:px-16">
            {title}
          </TitleLG>
        </header>
      )}

      <BasicCarousel containerClassName={classNames({ 'px-4 sm:px-8 md:px-12 xl:px-16 py-4 md:py-4': padding })}>
        {items.map((contentLink, idx) => (
          <div
            className="w-[160px] shrink-0 snap-center snap-always sm:w-[180px] md:w-[200px] lg:w-[220px]"
            key={`${contentLink?.id ?? contentLink?.linkUrl ?? contentLink?.imageUrl}-${idx}`}
          >
            <SquareTileCard className="mb-2" linkModel={contentLink as LinkViewModel} />
          </div>
        ))}
      </BasicCarousel>
    </div>
  )
}
